import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20entertainment%20background%20with%20soft%20coral%20rose%20gold%20and%20cream%20gradient%2C%20elegant%20editorial%20magazine%20cover%20style%2C%20sophisticated%20luxurious%20texture%2C%20cinematic%20spotlight%20effect%2C%20high%20end%20fashion%20and%20lifestyle%20aesthetic%2C%20warm%20dreamy%20atmosphere&width=1600&height=900&seq=hero-bg-51cg&orientation=landscape"
          alt="51cg今日大瓜必吃大瓜娱乐资讯背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-5">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-xs font-medium text-accent-600 whitespace-nowrap">今日必吃大瓜</span>
              </div>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight tracking-tight">
                51cg - 全网最热吃瓜第一站
              </h1>

              <p className="mt-3 text-base md:text-lg text-white/80 font-medium leading-relaxed">
                51cgfun今日吃瓜，朝阳群众都在看的娱乐爆料平台
              </p>

              <p className="mt-5 text-sm md:text-base text-white/65 leading-relaxed max-w-[560px] lg:max-w-none">
                覆盖<span className="text-accent-400 font-medium">51cgfun今日吃瓜</span>、<span className="text-accent-400 font-medium">51cg.fun今日吃瓜</span>及全网<span className="text-accent-400 font-medium">51cg吃瓜</span>热点事件。
                从明星恋情到综艺名场面，从影视票房到网红翻车，<span className="text-accent-400 font-medium">51cg今日大瓜必吃大瓜</span>一网打尽。
                每天更新200+条热门资讯，紧跟朝阳群众吃瓜动态，<span className="text-accent-400 font-medium">51cg最新吃瓜</span>永不掉队。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
                {heroStats.map((stat, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <span className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                      {stat.value}
                    </span>
                    <span className="text-xs md:text-sm text-white/55">
                      {stat.label}
                      {stat.unit}
                    </span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
                <a
                  href="#index"
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-base"></i>
                  立即吃瓜
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line text-base"></i>
                  下载APP
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end">
              <div className="relative w-[280px] sm:w-[340px] md:w-[400px] lg:w-[460px] aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20spots%20and%20blurred%20circles%20on%20deep%20coral%20background%2C%20artistic%20minimalist%20composition%2C%20entertainment%20media%20visual%20with%20sophisticated%20gradient%20texture%2C%20modern%20editorial%20design%20aesthetic%2C%20luxurious%20warm%20atmosphere&width=920&height=690&seq=hero-visual-51cg&orientation=landscape"
                  alt="51cg吃瓜热闻主视觉"
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 rounded-2xl bg-accent-500/10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <a
          href="#features"
          className="flex flex-col items-center gap-1 text-white/50 hover:text-white/80 transition-colors duration-200 cursor-pointer"
        >
          <span className="text-xs">向下滚动</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}